import { CommandActivity, ModuleTableEnum } from '../../types/activityLog';

export const configFilterModule = [
  {
    text: ModuleTableEnum.TOUR_TRASH,
    value: ModuleTableEnum.TOUR_TRASH,
  },
  {
    text: ModuleTableEnum.HOME_WIDGETS,
    value: ModuleTableEnum.HOME_WIDGETS,
  },
  {
    text: ModuleTableEnum.PERK,
    value: ModuleTableEnum.PERK,
  },
  {
    text: ModuleTableEnum.TTB,
    value: ModuleTableEnum.TTB,
  },
  {
    text: ModuleTableEnum.TTB_FRAUD,
    value: ModuleTableEnum.TTB_FRAUD,
  },
  {
    text: ModuleTableEnum.USER_BLACKLIST,
    value: ModuleTableEnum.USER_BLACKLIST,
  },
  {
    text: ModuleTableEnum.USER,
    value: ModuleTableEnum.USER,
  },
  {
    text: ModuleTableEnum.PRODUCT_ORDER,
    value: ModuleTableEnum.PRODUCT_ORDER,
  },
  {
    text: ModuleTableEnum.PAID_FEATURE,
    value: ModuleTableEnum.PAID_FEATURE,
  },
  {
    text: ModuleTableEnum.LAUNCH_FEATURES,
    value: ModuleTableEnum.LAUNCH_FEATURES,
  },
  {
    text: ModuleTableEnum.SHOW_FEATURES,
    value: ModuleTableEnum.SHOW_FEATURES,
  },
  {
    text: ModuleTableEnum.LOYALTY_ACTION,
    value: ModuleTableEnum.LOYALTY_ACTION,
  },
];

export const configFilterCommand = [
  {
    text: CommandActivity.INSERT,
    value: CommandActivity.INSERT,
  },
  {
    text: CommandActivity.UPDATE,
    value: CommandActivity.UPDATE,
  },
  {
    text: CommandActivity.DELETE,
    value: CommandActivity.DELETE,
  },
];
